<template>
  <v-dialog
    v-model="_active"
    @click:outside="_setActive(false)"
    :fullscreen="showMobileView"
    :width="showMobileView ? '' : '700'"
  >
    <v-card v-if="phase === 'preExport' && dataset">
      <v-card v-if="showMobileView" class="pb-4">
        <v-card-text class="pl-8 text-subtitle-1 black--text pb-1 pt-6">
          {{ dataset.title }}
        </v-card-text>
        <v-divider />
        <div v-for="(data, i) in dataset.fields" :key="i">
          <div
            v-if="data.text !== 'RA#' || _client.client_name !== 'shark'"
            class="d-flex justify-space-between mx-4"
          >
            <v-card-text class="py-1">
              {{ data.text }}
            </v-card-text>
            <v-checkbox
              hide-details
              dense
              class="ma-0"
              v-model="data.selected"
            />
          </div>
        </div>
        <v-divider />
        <v-card-text class="pl-8 pt-4 pb-1 text-subtitle-1 black--text">
          Export Type
        </v-card-text>
        <v-divider />
        <div class="d-flex justify-space-between mx-4 mt-2">
          <v-card-text class="py-1">
            CSV
          </v-card-text>
          <v-checkbox hide-details dense class="ma-0" v-model="csv" />
        </div>
        <div class="d-flex justify-space-between mx-4">
          <v-card-text class="py-1">
            Excel Document
          </v-card-text>
          <v-checkbox hide-details dense class="ma-0" v-model="excel" />
        </div>
        <v-divider />
        <div class="d-flex justify-space-around">
          <v-btn
            color="secondary"
            width="170"
            :disabled="disableExport"
            tile
            class="mt-4 white--text"
            @click="exportReport"
          >
            <v-icon>mdi-download</v-icon>
            EXPORT
          </v-btn>
          <v-btn
            color="secondary"
            width="170"
            tile
            class="mt-4 white--text"
            @click="_setActive(false)"
          >
            <v-icon>mdi-close</v-icon>
            CLOSE
          </v-btn>
        </div>
      </v-card>
      <v-card v-if="!showMobileView" class="pa-4">
        <div class="d-flex justify-center">
          <v-card outlined class="ma-4" width="300">
            <v-card-text class="pl-8 text-subtitle-1 black--text pb-1 pt-4">
              {{ dataset.title }}
            </v-card-text>
            <div class="mb-4">
              <div v-for="(data, i) in dataset.fields" :key="i">
                <div
                  v-if="data.text !== 'RA#' || _client.client_name !== 'shark'"
                  class="d-flex justify-space-between mx-4"
                >
                  <v-card-text class="py-1">
                    {{ data.text }}
                  </v-card-text>
                  <v-checkbox
                    hide-details
                    dense
                    class="ma-0"
                    v-model="data.selected"
                  />
                </div>
              </div>
            </div>
          </v-card>
          <v-card outlined class="ma-4" width="300">
            <v-card-text class="pl-8 pt-4 pb-1 text-subtitle-1 black--text">
              Export Type
            </v-card-text>
            <div class="d-flex justify-space-between mx-4 mt-2">
              <v-card-text class="py-1">
                CSV
              </v-card-text>
              <v-checkbox hide-details dense class="ma-0" v-model="csv" />
            </div>
            <div class="d-flex justify-space-between mx-4">
              <v-card-text class="py-1">
                Excel Document
              </v-card-text>
              <v-checkbox hide-details dense class="ma-0" v-model="excel" />
            </div>
          </v-card>
        </div>
        <div class="d-flex justify-center">
          <v-btn
            color="secondary"
            width="170"
            tile
            :disabled="disableExport"
            class="mt-4 white--text"
            @click="exportReport"
          >
            <v-icon>mdi-download</v-icon>
            EXPORT
          </v-btn>
        </div>
      </v-card>
    </v-card>
    <div v-if="phase === 'loading'">
      <loading />
    </div>
    <v-card height="300" v-if="phase === 'exported'">
      <div class="d-flex">
        <v-card-text class="text-h4 pt-7 pl-8">
          Your download is ready
        </v-card-text>
        <v-btn class="ma-8" @click="_setActive(false)">
          <v-icon>
            mdi-close
          </v-icon>
          Close
        </v-btn>
      </div>
      <div class="d-flex">
        <a :href="_exportURL.csv" v-if="csv === true">
          <v-card-text class="text-h6 px-8">
            CSV
          </v-card-text>
        </a>
        <a :href="_exportURL.excel" v-if="excel === true">
          <v-card-text class="text-h6 px-8">
            Excel
          </v-card-text>
        </a>
      </div>
      <div class="d-flex justify-center">
        <v-btn
          color="secondary"
          width="170"
          tile
          class="mt-14 ml-7 white--text"
          @click="phase = 'preExport'"
        >
          <v-icon>mdi-download</v-icon>
          EXPORT AGAIN
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Loading from '@/components/export/Loading';
import MobileView from '@/mixins/MobileView';

export default {
  mixins: [MobileView],
  components: {
    Loading,
  },
  props: ['tab'],
  data() {
    return {
      csv: true,
      excel: true,
      phase: 'preExport',
    };
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
  },
  methods: {
    ...mapMutations({
      _setActive: 'reports/setExport',
    }),
    ...mapActions({
      _exportRentalReport: 'reports/exportRentalReport',
      _exportChargedOffReport: 'reports/exportChargedOffReport',
      _exportUtilizationReport: 'reports/exportUtilizationReport',
      _exportSharkReport: 'reports/exportSharkReport',
    }),
    exportReport() {
      if (this._client.client_name === 'shark') {
        this.exportSharkReport(this.payload);
      } else if (this.tab === 0) {
        this._exportRentalReport(this.payload);
        this.phase = 'loading';
      } else if (this.tab === 1) {
        this._exportChargedOffReport(this.payload);
        this.phase = 'loading';
      } else if (this.tab === 2) {
        this._exportUtilizationReport(this.payload);
        this.phase = 'loading';
      }
    },
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
      _active: 'reports/getExport',
      _exportData: 'reports/getExportData',
      _exportURL: 'reports/getExportURL',
    }),
    dataset() {
      if (this.tab === 0) {
        return this._exportData.rentals;
      } if (this.tab === 1) {
        return this._exportData.chargedOff;
      } if (this.tab === 2) {
        return this._exportData.utilization;
      }
      return null;
    },
    payload() {
      return {
        csv: this.csv,
        excel: this.excel,
      };
    },
    disableExport() {
      if ((this.csv || this.excel) && this.dataBoolean) {
        return false;
      }
      return true;
    },
    dataBoolean() {
      for (let i = 0; i < this.dataset.fields.length; i += 1) {
        if (this.dataset.fields[i].selected) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    _exportURL: {
      handler() {
        if (this._exportURL.loaded) {
          this.phase = 'exported';
        }
      },
      deep: true,
    },
    tab() {
      this.phase = 'preExport';
    },
  },
};
</script>
